var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclaimation = function SvgExclaimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 107,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.719 96.423c0-2.844 1.015-5.18 3.047-7.008 2.03-1.828 4.443-2.742 7.236-2.742 2.844 0 5.256.914 7.236 2.742 2.032 1.828 3.047 4.164 3.047 7.008 0 2.844-1.015 5.205-3.047 7.084-1.98 1.828-4.392 2.742-7.236 2.742-2.793 0-5.205-.914-7.236-2.742-2.032-1.879-3.047-4.24-3.047-7.084ZM1.633.75h18.814l-2.056 72.668H3.613L1.633.75Z",
    fill: "#C72A14"
  })));
};
export default SvgExclaimation;